import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import de from 'vuetify/src/locale/de';
import en from 'vuetify/src/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
  theme: { dark: true, themes: { dark: { primary: '#ae8a1e', secondary: '#795548', accent: '#795548' } } },
  locale: {
    locales: { de, en },
    current: 'de',
  },
  icons: {
    iconfont: 'mdiSvg',
  },
});
